/*
 * ⚡ 17 Ağu — SAYFA HIZI: taşan filtre seçenekleri <template> içinde geliyor.
 *
 * `facets.liquid` yalnız ilk 14 seçeneği (+ aktif olanları) canlı DOM'a basar;
 * kalanı `<template data-facet-overflow>` içinde durur. Template içeriği
 * tarayıcı tarafından DOM'a KURULMAZ (stil/layout maliyeti yok) — ölçüldü:
 * koleksiyon sayfasında 932 gizli seçenek bu şekilde DOM dışına çıktı.
 *
 * Bu dosya, kullanıcı "daha fazla göster"e ilk kez bastığında içeriği listeye
 * taşır (bir kez, sonra template boşalır) ve ardından mevcut göster/gizle
 * davranışı hiç değişmeden çalışmaya devam eder.
 */
if (!customElements.get('show-more-button')) {
  customElements.define(
    'show-more-button',
    class ShowMoreButton extends HTMLElement {
      constructor() {
        super();
        const button = this.querySelector('button');
        button.addEventListener('click', (event) => {
          this.hydrateOverflow(event);
          this.expandShowMore(event);
          const nextElementToFocus = event.target.closest('.parent-display').querySelector('.show-more-item');
          if (nextElementToFocus && !nextElementToFocus.classList.contains('hidden') && nextElementToFocus.querySelector('input')) {
            nextElementToFocus.querySelector('input').focus();
          }
        });
      }

      /* Template'teki seçenekleri bir kereye mahsus gerçek listeye taşı. */
      hydrateOverflow(event) {
        const parentDisplay = event.target.closest('[id^="Show-More-"]').closest('.parent-display');
        if (!parentDisplay) return;
        const tpl = parentDisplay.querySelector('template[data-facet-overflow]');
        if (!tpl) return;
        const list = parentDisplay.querySelector('ul[data-facet-list]');
        if (!list) return;
        list.appendChild(tpl.content.cloneNode(true));
        tpl.remove();
      }

      expandShowMore(event) {
        const parentDisplay = event.target.closest('[id^="Show-More-"]').closest('.parent-display');
        const parentWrap = parentDisplay.querySelector('.parent-wrap');
        this.querySelectorAll('.label-text').forEach((element) => element.classList.toggle('hidden'));
        parentDisplay.querySelectorAll('.show-more-item').forEach((item) => item.classList.toggle('hidden'));
        if (!this.querySelector('.label-show-less')) {
          this.classList.add('hidden');
        }
      }
    }
  );
}
